/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const SelectionDot: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="4" fill={color} />
  </svg>
}
